<template>
  <div class="sign_in container">
    <div class="top">
      <div class="back_box">
        <!-- <img src="@/assets/images/icons/icon_back.png" alt="" /> -->
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div class="info">
        <img class="icon" src="@/assets/images/icons/a_sign.png" alt="" />
        <div class="mid">
          <p class="title">{{ info.name }}</p>
          <p style="margin-top: 5px">
            <span class="time">{{
              formatDate(info.startTime, "MM-DD HH:mm")
            }}</span>
            <span class="shu">|</span>
            <span class="surplus" v-if="info.status == 'STARTED'"
              >剩余<i class="el-icon-time"></i>{{ surplus }}</span
            >
            <span class="end_tag" v-else>已结束</span>
          </p>
        </div>
      </div>
    </div>
    <div class="main">
      <div
        class="sign_btn"
        v-if="!isSign && info.status == 'STARTED'"
        @click="handleSign"
      >
        签到
      </div>
      <div class="sign_success" v-else-if="isSign">
        <img src="@/assets/images/icons/icon_right.png" alt="" />
        <p class="tips">签到成功</p>
        <p class="time">{{ signTime }}</p>
      </div>
      <p class="end_tips" v-else>签到已结束!</p>
    </div>
  </div>
</template>

<script>
import { sign, signInfo } from "@/api/activity/sign";
import { activityInfo } from "@/api/activity";
import { formatDate, dateCount } from "@/utils/index";
export default {
  name: "sign",
  data() {
    return {
      formatDate,
      info: {},
      surplus: "",
      signTime: "",
      isSign: false,
    };
  },
  created() {
    this.getInfo();
  },
  beforeDestroy() {
    clearInterval(this.timerId);
  },
  methods: {
    // 活动信息
    getInfo() {
      let activityId = this.$route.query.activityId;
      activityInfo(activityId).then((res) => {
        if (res.code == 0) {
          this.info = res.data;
          let end = new Date(this.info.startTime).getTime();
          let duration = this.info.duration * 60 * 1000;
          end = end + duration;
          let nowTime = +new Date();
          let times = (end - nowTime) / 1000;
          if (times > 0) {
            this.surplus = dateCount(times);
            this.timerId && clearInterval(this.timerId);
            this.timerId = setInterval(() => {
              if (times <= 0 && this.timerId) {
                clearInterval(this.timerId);
                this.getInfo();
              }
              this.surplus = dateCount(times);
              times--;
            }, 1000);
          }
        } else {
          console.log(res.msg);
        }
      });

      signInfo(activityId).then((res) => {
        if (res.code == 0) {
          this.isSign = !!res.data;
          this.signTime = res.data ? res.data.createTime : "";
        } else {
          console.log(res.msg);
        }
      });
    },
    // 点击签到
    handleSign() {
      sign(this.$route.query.activityId).then((res) => {
        if (res.code == 0) {
          this.$message.success("签到成功");
          this.getInfo();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.sign_in {
  height: 100%;
  .top {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    .back_box {
      display: inline-block;
      width: calc(100% - 1126px);
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      img {
        width: 44px;
      }
      p {
        color: #969696;
        font-size: 16px;
      }
    }
    .info {
      position: relative;
      display: inline-block;
      padding: 24px 30px;
      background-color: #fff;
      width: 1126px;
      vertical-align: middle;
      .icon {
        width: 44px;
        height: 44px;
      }
      .mid {
        display: inline-block;
        margin-left: 20px;
        vertical-align: middle;
      }

      .title {
        font-size: 16px;
        color: #333;
      }
      .time {
        margin-top: 5px;
        color: #999;
        font-size: 14px;
      }

      .shu {
        padding: 0 10px;
        color: #ddd;
      }
      .el-icon-time {
        margin: 0 5px;
      }
      .surplus {
        color: sandybrown;
      }
      .end_tag {
        color: #c8c8c8;
      }
    }
  }
  .main {
    position: relative;
    padding: 60px 280px;
    height: calc(100% - 30px - 20px - 88px - 30px);
    background-color: #fff;
    // text-align: left;
    overflow: auto;
    .sign_btn {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 120px;
      height: 120px;
      line-height: 120px;
      background: #1890ff;
      font-size: 28px;
      color: #ffffff;
      border-radius: 50%;
      transition: all 0.3s ease;
      cursor: pointer;
      &:hover {
        box-shadow: 0px 0px 10px 0px #1890ff;
      }
    }
    .sign_success,
    .end_tips {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      &.end_tips {
        font-size: 28px;
        color: #969696;
      }
      &.sign_success {
        img {
          width: 44px;
          height: 44px;
        }
        .tips {
          margin-top: 10px;
          color: #1890ff;
          font-weight: bold;
          font-size: 28px;
        }
        .time {
          margin-top: 5px;
          font-size: 16px;
          color: #969696;
        }
      }
    }
  }
}
</style>